import Box from '@redbubble/design-system/src/Box';
import Button from '@redbubble/design-system/src/Button';
import * as constants from '@redbubble/design-system/src/constants';
import Input from '@redbubble/design-system/src/Form/Input';
import SearchIcon from '@redbubble/design-system/src/Icons/Search';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import React, { useCallback, useState } from 'react';
import styles from './styles.module.scss';

const messages = defineMessages({
  placeholder: { defaultMessage: 'Search products, artworks, themes' },
  searchButton: { defaultMessage: 'Search' },
});

const SearchForm = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const intl = useIntl();

  // Search Form
  // biome-ignore lint/correctness/useExhaustiveDependencies: useExhaustiveDependencies
  const updateSearchTerm = useCallback(
    (e) => {
      setSearchTerm(e.target.value);
    },
    [setSearchTerm]
  );

  const doSearch = useCallback(() => {
    window.location.href = `${window.location.origin}/shop/${searchTerm}`;
  }, [searchTerm]);

  return (
    <Box display="flex" justifyContent="center">
      <Box
        className={styles.maxWidth}
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Input
          onChange={updateSearchTerm}
          type="search"
          fluid
          name="term"
          placeholder={intl.formatMessage(messages.placeholder)}
        />

        <Box marginBottom="s" />

        <Button
          type="button"
          onClick={doSearch}
          strong
          intent={constants.PRIMARY}
          iconAfter={<SearchIcon />}
          size={constants.LARGE}
        >
          {intl.formatMessage(messages.searchButton)}
        </Button>
      </Box>
    </Box>
  );
};

export default SearchForm;
